import { useState } from "react"
import { debounce } from "lodash"
import PropTypes from "prop-types"

// components
import { Select } from "components-design-system"

// apis
import { useGetTags } from "api/hooks/enum"

// styling
import "./TagsField.scss"

const TagsField = ({ value, onChange }) => {
  const [searchValue, setSearchValue] = useState("")

  // Fetch tag options based on the current tags
  const { data: tagOptions = [] } = useGetTags({ query: searchValue })

  // Debounce the search value to prevent too many requests
  const handleSearch = debounce((value) => {
    setSearchValue(value)
  }, 350)

  const handleChange = (value) => {
    onChange(value)
    setSearchValue("")
  }

  return (
    <Select
      value={value}
      mode="tags"
      options={tagOptions}
      onChange={handleChange}
      onSearch={handleSearch}
    />
  )
}

TagsField.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
}

export default TagsField
